import { applyFilters } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, ToggleControl, TextareaControl } from '@wordpress/components';
import Select from 'react-select'

export default () => {

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { disable_email_powered_by_text, email_template_powered_by_text, show_wp_travel_utilities, options, modules } = allData;
    const { updateSettings } = dispatch('WPTravel/Admin');
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;


    let disable_powered_by = 'undefined' != typeof disable_email_powered_by_text ? disable_email_powered_by_text : 'no'
    // if ( 'no' == show_wp_travel_utilities ) {
    //     return <p>{__('WP Travel Utilities is currently disabled please go to Addons Settings to enable it to use  "Remove Powered By" feature and reload the page.')}</p>
    // }
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
        <PanelRow>
            <label>{_wp_travel.setting_strings.email.remove_powered_by_text}</label>
            <div id="wp-travel-general-email-settings-remove-poweredby-text" className="wp-travel-field-value">
                <ToggleControl
                    checked={ disable_powered_by == 'yes' }
                    onChange={ () => {
                        updateSettings({
                            ...allData,
                            disable_email_powered_by_text: 'yes' == disable_powered_by ? 'no': 'yes'
                        })
                    } }
                />
                <p className="description">{_wp_travel.setting_strings.email.remove_powered_by_text_note}</p>
            </div>
        </PanelRow> 

        <PanelRow>
            <label>{ _wp_travel.setting_strings.email.custom_powered_by_text }</label>
            <div id="wp-travel-general-email-settings-custom-poweredby-text" className="wp-travel-field-value">
                <TextareaControl
                    value={email_template_powered_by_text}
                    onChange={ 
                        (value) => {
                            updateSettings({
                                ...allData,
                                email_template_powered_by_text: value
                            })
                        }
                    }
                />
                <p className="description">{_wp_travel.setting_strings.email.custom_powered_by_text_note}</p>
            </div>
        </PanelRow>

    </>
}